export default __webpack_public_path__ + "static/media/profile-female.79b793fb.jpg";